import { render, staticRenderFns } from "./FinancialStatementBillingPendenciesEconomicGroup.vue?vue&type=template&id=ad4a0a62"
import script from "./FinancialStatementBillingPendenciesEconomicGroup.vue?vue&type=script&lang=ts"
export * from "./FinancialStatementBillingPendenciesEconomicGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports